import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminPageLayout } from '@/layouts/AdminPageLayout';
import { VoucherForm } from '@/components/vouchers/VoucherForm';
import { createVouchersService } from '@/services/admin/vouchers/vouchers.service';
import { CreateVoucherFormData } from '@/components/vouchers/schemas';
import { useToast } from '@/components/ui/use-toast';

const CreateVoucherPage: React.FC = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const vouchersService = createVouchersService();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (data: CreateVoucherFormData) => {
    try {
      setIsLoading(true);
      
      // Converter dados do formulário para o formato da API
      const voucherData = {
        code: data.code,
        name: data.name,
        description: data.description,
        isActive: data.isActive,
        voucherKind: data.voucherKind ?? 'discount',
        durationDays: data.voucherKind === 'time' ? data.durationDays : undefined,
        discountType: data.voucherKind === 'time' ? 'percentage' : data.discountType,
        discountValue: data.voucherKind === 'time' ? 0 : data.discountValue,
        freeShipping: data.freeShipping,
        maxUses: data.maxUses,
        maxUsesPerUser: data.maxUsesPerUser,
        validFrom: data.validFrom,
        validUntil: data.validUntil,
        timezone: data.timezone,
        packageRestrictions: data.packageRestrictions,
        categoryRestrictions: data.categoryRestrictions,
        productRestrictions: data.productRestrictions,
      };

      await vouchersService.createVoucher(voucherData);
       showToast('Voucher criado com sucesso!', 'success');
      navigate('/admin/vouchers');
    } catch (error) {
      console.error('Erro ao criar voucher:', error);
      
      showToast('Erro ao criar voucher', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/admin/vouchers');
  };

  return (
    <AdminPageLayout title="Criar Voucher">
      <main className="py-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold">Criar Novo Voucher</h1>
          <p className="text-gray-600">
            Configure um novo cupom de desconto ou promoção
          </p>
        </div>

        <VoucherForm
          mode="create"
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isLoading={isLoading}
        />
      </main>
    </AdminPageLayout>
  );
};

export default CreateVoucherPage;
